
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as terms1wCL_jcKgXyjae_4516VMbFrKHvZd0F4Waht3oN_MqrwYMeta } from "/app/pages/terms.vue?macro=true";
import { default as index_OvrHobNBlyrahkYsomE34aM4tqOlcAg5_45MV7YzEWJEMeta } from "/app/pages/[user]/index.vue?macro=true";
import { default as membershipsNOAofJowJZM42qFwzg2Cb7jVM9VmVhH6fMtdSBDBe8MMeta } from "/app/pages/[user]/memberships.vue?macro=true";
import { default as _91user_93aYW9fUd6SgFY363NRRl0XJTBdSvWBP1HRb1H_45pLkRBMMeta } from "/app/pages/[user].vue?macro=true";
import { default as upload0DI_uS6AXpmsWT7KsHWAxlk4dp6_swCQLNoEYksdOYgMeta } from "/app/pages/upload.vue?macro=true";
import { default as privacyxyrJyjSeOpGN_D08QZsO5Csr7DLueZBtja09XVxe_45u0Meta } from "/app/pages/privacy.vue?macro=true";
import { default as indexvhfhWVotO_456VvDOq_45cYkZMmeSIieYf1jIKy2UpS3yT0Meta } from "/app/pages/auth/index.vue?macro=true";
import { default as registerP6kYPRY6AO3o2k9aPJs1KTHwpt17Hy4EvBog_g8SDPYMeta } from "/app/pages/auth/register.vue?macro=true";
import { default as indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta } from "/app/pages/settings/index.vue?macro=true";
import { default as indexrSYfhlGdEHXWTTj__PtooLvviNKkQowhicm5U3_45DDEYMeta } from "/app/pages/settings/user/index.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "terms",
    path: "/terms",
    component: () => import("/app/pages/terms.vue")
  },
  {
    name: _91user_93aYW9fUd6SgFY363NRRl0XJTBdSvWBP1HRb1H_45pLkRBMMeta?.name,
    path: "/:user()",
    component: () => import("/app/pages/[user].vue"),
    children: [
  {
    name: "user",
    path: "",
    component: () => import("/app/pages/[user]/index.vue")
  },
  {
    name: "user-memberships",
    path: "memberships",
    component: () => import("/app/pages/[user]/memberships.vue")
  }
]
  },
  {
    name: "upload",
    path: "/upload",
    meta: upload0DI_uS6AXpmsWT7KsHWAxlk4dp6_swCQLNoEYksdOYgMeta || {},
    component: () => import("/app/pages/upload.vue")
  },
  {
    name: "privacy",
    path: "/privacy",
    component: () => import("/app/pages/privacy.vue")
  },
  {
    name: "auth",
    path: "/auth",
    component: () => import("/app/pages/auth/index.vue")
  },
  {
    name: "auth-register",
    path: "/auth/register",
    component: () => import("/app/pages/auth/register.vue")
  },
  {
    name: "settings",
    path: "/settings",
    meta: indexDLzw_45g6D6DIAJf6VenrnDjf_u_45_OCTUbhH1U0CiVKeoMeta || {},
    component: () => import("/app/pages/settings/index.vue")
  },
  {
    name: "settings-user",
    path: "/settings/user",
    meta: indexrSYfhlGdEHXWTTj__PtooLvviNKkQowhicm5U3_45DDEYMeta || {},
    component: () => import("/app/pages/settings/user/index.vue")
  }
]